import { mapActions } from 'vuex';

import { router } from '_/router/router';

import i18n from '_/i18n';

export default {
    /**
     * Set the component data
     *
     * @return  {object}
     */
    data: function () {
        return {
            error: {
                info: i18n.t('apiOverdraft.apiOverdraftProblemExplanation'),
                title: i18n.t('apiOverdraft.apiOverdraftProblem'),
            },
            isLoading: false,
        };
    },

    /**
     * Set the computed variables
     *
     * @type  {object}
     */
    computed: {
        getActionButtonLink() {
            return 'https://photoncms.com/projects';
        },
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        ...mapActions('ui', ['setBodyClass']),

        ...mapActions('user', ['refreshApiOverdraftStatus']),

        /**
         * Bootstraps the component
         *
         * @param   {string}  errorType
         * @return  {void}
         */
        bootstrap() {
            this.setBodyClass('dashboard-page');
        },

        /**
         * Force refreshes the status
         *
         * @return  {void}
         */
        refreshStatus() {
            this.isLoading = true;

            this.refreshApiOverdraftStatus().then((response) => {
                this.isLoading = false;

                if (response.api_overdraft_status) {
                    return router.push('/api-calls-exceeded');
                }

                return router.push('/');
            });
        },
    },

    /**
     * Call a mounted hook
     *
     * @type  {function}
     * @return  void
     */
    mounted: function () {
        this.$nextTick(function () {
            this.bootstrap();
        });
    },

    /**
     * Define watched properties
     *
     * @type  {Object}
     */
    watch: {
        /**
         * Watching the route change
         *
         * @return  {void}
         */
        $route: {
            deep: true,
            handler(newEntry) {
                const errorType = newEntry.params.errorType;

                this.bootstrap(errorType);
            },
        },
    },
};
